export { default } from './SingleHorizontalAnswerQuizStep';
